function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6 17a1 1 0 011-1h12a1 1 0 110 2H7a1 1 0 01-1-1zM7 20a1 1 0 100 2h7a1 1 0 100-2H7z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 8a3 3 0 013-3h24a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3V8zm2 0a1 1 0 011-1h24a1 1 0 011 1v3H3V8zm26 5v11a1 1 0 01-1 1H4a1 1 0 01-1-1V13h26z",
  fill: "currentColor"
})));